import { createI18n } from 'vue-i18n'
import { ref } from 'vue'
import { useLocalStorage } from '@vueuse/core'
// import zhCH from './language/zh-ch'
import en from './language/en'
import de from './language/de'

/**
 * Amount formatting
 */
export function formatAmountFunc(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}


const langRef = useLocalStorage('language', 'en')

const messages = { en, de }

const i18n = createI18n({ locale: langRef.value, messages })

const languageList = Object.keys(messages).map(k =>
  ({ label: messages[k].title, value: k })
)
const languageShow = ref(false)

const setLanguage = (item = { label: '', value: '' }) => {
  if(langRef.value == item.value) return
  i18n.locale = item.value
  langRef.value = item.value
  languageShow.value = false
  setTimeout(() => {
    location.reload()
  }, 300);
}

const t = i18n.global.t

const moneyFlag = '$'

const fm = (money) => {
  let _val = formatAmountFunc(parseFloat(money||0).toFixed(2))
  return `${moneyFlag} ${_val}`
}

const fn = (money) => {
  let _val = formatAmountFunc(parseFloat(money||0).toFixed(2))
  return _val
}

export default i18n
export { t, langRef, languageList, languageShow, setLanguage, fm, fn }
